"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStructPaths = void 0;
var generatePath = function (isArray, currentPath, newPath, lodashLike) {
  var prefix = lodashLike ? isArray ? '[' : '.' : '/';
  var suffix = lodashLike ? isArray ? ']' : '' : isArray ? '[]' : '';
  var path = currentPath !== '' ? "" + currentPath + prefix + newPath + suffix : "" + (lodashLike && isArray ? '[' : '') + newPath + suffix;
  return path;
};
var getStructPaths = function (struct, isLodashLike, paths, currentPath) {
  if (isLodashLike === void 0) {
    isLodashLike = false;
  }
  if (paths === void 0) {
    paths = {};
  }
  if (currentPath === void 0) {
    currentPath = '';
  }
  for (var _i = 0, _a = Object.keys(struct); _i < _a.length; _i++) {
    var key = _a[_i];
    var path = generatePath(Array.isArray(struct), currentPath, key, isLodashLike);
    if (typeof struct[key] === 'object' && struct[key] !== null) {
      if (Object.keys(struct[key]).length === 0) {
        paths[path] = struct[key];
      }
      (0, exports.getStructPaths)(struct[key], isLodashLike, paths, path);
    } else {
      paths[path] = struct[key];
    }
  }
  return paths;
};
exports.getStructPaths = getStructPaths;